import { Component, EventEmitter, OnInit, Output, computed, input } from '@angular/core';
import { Asset } from 'app/classes/asset';
import { StoreService, ThemeType } from 'app/shared/store.service';

@Component({
  selector: 'app-dashboard-telemetry-asset',
  templateUrl: './dashboard-telemetry-asset.component.html',
  styleUrls: ['./dashboard-telemetry-asset.component.css'],
  standalone: false
})
export class DashboardTelemetryAssetComponent implements OnInit {

  asset = input<Asset | undefined>(undefined);

  assetTransformed = computed(() => {
    if (this.asset() instanceof Asset) {

      return this.asset();
    } else {
      const asset = new Asset(this.asset());

      return asset;
    }
  });

  @Output()
  onAssetClick: EventEmitter<any> = new EventEmitter();

  theme: ThemeType;

  constructor(private storeService: StoreService) {
    this.theme = storeService.getTheme(true);
  }

  ngOnInit(): void {

  }

  assetClick() {
    this.onAssetClick.emit(true);
  }

  displayValue() {
    const asset = this.asset();

    if (asset.formattedValue !== undefined && asset.formattedValue !== null) return asset.formattedValue;

    return String(Asset.formattedValue(asset.value, asset.assetType, asset.purposeId, asset.updatedAt, asset.identifier));
  }

}
